<div>
  <div *ngIf="AllHistory.length" class="row mainLine">
    <div class="col historyLine">
      <div class="timeline-line float-right margin-right-25 fixedLeft">
        <div class="item-timeline mr-5">
          <div class="t-dot t-dot-primary"></div>
          <p class="t-time ft-11 ">
            <span class="text">
              {{ "NOTIFICATION.STATUS.NEW" | translate }}
            </span>
            <br/>
            {{
            AllHistory[0]?.jobRequest.createdAt
              | date: "dd/MM/yy HH:mm "
            }}
          </p>
          <!--
                    <div class="t-text d-md-flex">
                      <div>
                        <p>pickUp Time :</p>
                      </div>
                      <div class="text-center">
                        <p class="text-info">
                          {{ AllHistory[0]?.jobRequest.startDate | date }}
                        </p>
                        <p class="text-info">
                          {{
                          AllHistory[0]?.jobRequest.startDate | date: "HH:mm "
                          }}
                          >
                          {{ AllHistory[0]?.jobRequest.endDate | date: "HH:mm " }}
                        </p>
                      </div>
                    </div>
                    -->
        </div>
        <div *ngFor="let item of AllHistory" class="item-timeline">
          <div class="t-dot t-dot-primary" *ngIf="item.status != 1 &&item.status != 2 "></div>

          <div class="t-time"  *ngIf="item.status != 1 &&item.status != 2 ">
            <div class="t-block">
              <p class="ft-11 ml-3 mt-3 mb-0">
                <app-history-badge-status
                  [item]="item"
                >
                </app-history-badge-status>
                <span *ngIf="item.status == 6 || item.status == 16">
              {{ item?.centrale?.name }}
            </span>

              </p>
            </div>
            <!--
            <div class="t-block date-text d-none">
            <p class="mt-4 ml-2 ft-11 mb-0">{{ item.date | date: "dd/MM/yy HH:mm " }}</p>
              </div>
              -->
          </div>

        </div>
      </div>
    </div>

  </div>
  <div
    *ngIf="AllHistory.length == 0"
  >
    pas d'historique a affiché.
  </div>

</div>
